import logo from './logo.svg';
import './App.css';
import mqtt from "mqtt"; // import namespace "mqtt"
import { useEffect, useState, useRef } from 'react';
import HTMLFlipBook from 'react-pageflip';
import Lottie from 'react-lottie';
import { useIdleTimer } from 'react-idle-timer'
import * as animationData from './hand-swipe.json'
import espa from './visual_id_ESPA.png'
import logoMystras from './_mystras_logo.svg'





function App() {

const [sent, setSent] = useState(false)
// const imageCount = 511;
const imageCount = 122;
const [audio] = useState(new Audio('./flipPage.mp3'));
const flipBookRef = useRef(null)
const playButtonRef = useRef();


// Initializing values
var isPlaying = true;

// On audio playing toggle values
audio.onplaying = function() {
    isPlaying = true;
};

// On audio pause toggle values
audio.onpause = function() {
    isPlaying = false;
};
// Play audio function
async function playAudio() {      
    if (audio.paused && !isPlaying) {
        return audio.play();
    }
} 
// Pause audio function
function pauseAudio() {     
    if (!audio.paused && isPlaying) {
      audio.pause();
    }
}



const onIdle = () => {
  flipBookRef.current.pageFlip().turnToPage(0)
}
const [remaining, setRemaining] = useState(0)
const { getRemainingTime, start } = useIdleTimer({
  onIdle,
  timeout: 600_000,
  throttle: 500
})

useEffect(() => {
  const interval = setInterval(() => {
    setRemaining(Math.ceil(getRemainingTime() / 1000))
  }, 500)

  return () => {
    clearInterval(interval)
  }
})


// useEffect(() => {

//   const client = mqtt.connect("mqtt://10.1.1.121:9001");

//   client.on("connect", () => {
//     console.log("Connected to MQTT broker");

//     // Subscribe to a topic or perform other actions as needed
//     client.subscribe("/test");
//   });

//   client.on("message", (topic, message) => {
//     start()
//     // audio.pause(); 
//     // audio.currentTime = 0;
//     // audio.play()
//     console.log(`Received message on topic '${topic}': ${message.toString()}`);
//     if(message.toString() === 'right'){
//       flipBookRef.current.pageFlip().flipNext()
//     }
//     if(message.toString() === 'left'){
//       flipBookRef.current.pageFlip().flipPrev()
//     }
//     // setSent(message.toString())
//   });

//   client.on("error", (error) => {
//     console.error("MQTT connection error:", error);
//   });

//   client.on("close", () => {
//     console.log("Connection to MQTT broker closed");
//   });

// }, [])





useEffect(() => {

  const downHandler = ({ key }) => {
    if (key === 'ArrowRight') {
      flipBookRef.current.pageFlip().flipNext()
    }else if (key === 'ArrowLeft') {
      flipBookRef.current.pageFlip().flipPrev()
    }
  }

  const upHandler = ({ key }) => {
  };

  window.addEventListener("keydown", downHandler);
  window.addEventListener("keyup", upHandler);

  return () => {
    window.removeEventListener("keydown", downHandler);
    window.removeEventListener("keyup", upHandler);
  };

}, []);











  return (
    <div className="App" style={{width:'100vw', height:'100vh', overflow:'hidden', display:'flex', justifyContent:'center', alignItems:'center', position:'relative'}}>
      <div className='woodBg'></div>
      <div className='overlay'></div>
      <HTMLFlipBook 
        // startPage={12}
        startPage={0}
        ref={flipBookRef}
        width={(1000/2)*1.2} 
        height={720*1.2} 
        maxShadowOpacity={0.4} 
        style={{marginTop:100, userSelect:'none', boxShadow:'0px 30px 100px 30px #000'}}
        // onFlip={()=> audio.play()}
        onChangeState={(e)=>{
          if(e.data === 'flipping'){
            // pauseAudio(); 
            // setTimeout(() => {
              audio.pause()
              audio.currentTime = 0;
              // playAudio()
              audio.play()
            // }, 200);
          }
        }}
        useMouseEvents={false}
        flippingTime={550}
      >
      {/* {[...Array(imageCount).keys()].map((index) => (
        <img key={index} src={`./rendered2/${index}.jpg`} alt={`Image ${index}`} />
        // <img key={index} src={`./rendered2/${index+1}.jpg`} alt={`Image ${index+1}`} />
      ))} */}
      {[...Array(imageCount).keys()].map((index) => {
        if(index === 0){
          return(
            <img key={index} src={`./rendered2/0.jpg`} alt={`Image 0`} />
          )
        }else if(index === 1){
            return(
              <img key={index} src={`./rendered2/01.jpg`} alt={`Image 01`} />
            )
        }else{
          return <img key={index} src={`./rendered2/${index-1}.jpg`} alt={`Image ${index-1}`} />
        }
        // <img key={index} src={`./rendered2/${index+1}.jpg`} alt={`Image ${index+1}`} />
      })}
      </HTMLFlipBook>

      <Lottie 
        style={{position:'absolute', bottom:0, right:0}}
        options={{
          loop: true,
          autoplay: true, 
          animationData: animationData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
          }
        }}
        height={130}
        width={130}
      />

      <div style={{position:'absolute', top: 10, right:10, color:'white'}}>{remaining}</div>
      <div style={{position:'absolute', top: 30, left:30, color:'white'}}>
        <img src={espa} height="90" style={{display:'block'}} />
      </div>
      
      <div style={{position:'absolute', display:'flex', justifyContent:'center', alignItems:'center', width:'100%', height:160, zIndex:10, pointerEvents:'none', top:0, left:0}}>
        <img src={logoMystras} height="110" style={{display:'block'}} />
      </div>
    </div>
  );
}

export default App;
